declare global {
  interface Window {
    ym: any
  }
}

export function initYandexMetrika(counterId: string): void {
  if (!counterId || typeof counterId !== 'string') {
    return
  }

  // Проверяем что скрипт ещё не загружен
  const existingScript = document.querySelector(`script[src*="metrika/tag.js"]`)
  if (existingScript) {
    return
  }

  // Инициализация счётчика
  ;(function (m: any, e: Document, t: string, r: string, i: string, k?: any, a?: any) {
    m[i] =
      m[i] ||
      function () {
        ;(m[i].a = m[i].a || []).push(arguments)
      }
    m[i].l = 1 * new Date().getTime()
    for (let j = 0; j < e.scripts.length; j++) {
      if (e.scripts[j].src === r) {
        return
      }
    }
    k = e.createElement(t)
    a = e.getElementsByTagName(t)[0]
    k.async = 1
    k.src = r
    a.parentNode!.insertBefore(k, a)
  })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${counterId}`, 'ym')

  // Инициализация с параметрами
  window.ym(counterId, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  })

  // Добавляем noscript тег
  const noscript = document.createElement('noscript')
  const img = document.createElement('div')
  const imgEl = document.createElement('img')
  imgEl.src = `https://mc.yandex.ru/watch/${counterId}`
  imgEl.style.position = 'absolute'
  imgEl.style.left = '-9999px'
  imgEl.alt = ''
  img.appendChild(imgEl)
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}
